import Base from "components/Creation/components/Base";
import { useEffect, useState } from "react";

import BubblesGrid from "./components/BubblesGrid";
import useSelection from "hooks/useSelection";
import Warning from "../Warning";
import { useHistory } from "react-router-dom";
import MirumModal from "components/MirumModal";

const What = () => {
  const [selection, setSelection] = useState({}); //User selection stored here
  const [shouldAnimate, setShouldAnimate] = useState(true);
  const [isInSubCategory, setIsInSubCategory] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showConfirm, setShowConfirm] = useState({
    show: false,
    title: "are you sure?",
    // body: "are you sure you'd like to remove this activity?",
    onDidDismiss: () => {
      setShowConfirm({
        ...showConfirm,
        show: false,
      });
    },
    onPositiveBtnClick: () => {
      setShowConfirm({
        ...showConfirm,
        show: false,
      });
    },
  });

  const history = useHistory();

  const transformAndThenSetSelection = (storedSelection) => {
    let newSelection = {};
    storedSelection.forEach((activity) => {
      newSelection[activity.activity] = {};
      console.log("question transformAndThenSetSelection activity", activity);
      activity.selections.forEach((category) => {
        newSelection[activity.activity][category] = true;
      });
      if (activity.additionalQuestions) {
        newSelection[activity.activity].additionalQuestions =
          activity.additionalQuestions;
      }
    });
    console.log("set new selection", newSelection);
    setSelection(newSelection);
  };

  const { setSelectionForKey, redirectIfNotValidUpUntilKey, keyIsValidated } =
    useSelection({
      key: "what",
      setter: transformAndThenSetSelection,
    });

  //Array of objects [{ activity: "eat",selections:["carribean",indian] }]

  const defaultPositions = {
    9: {},
    2: { right: "50%", top: "40%" },

    7: {},
    3: { right: "50%", top: "40%" },
    15: { left: "50%", bottom: "40%" },
    17: { right: "50%", bottom: "40%" },
    5: { left: "50%", top: "40%" },
    4: { left: "50%", top: "40%" },
    13: { right: "60%", bottom: "40%" },
    14: { right: "50%", bottom: "40%" },
    20: { bottom: "100%", left: "50%" },
  };

  const addMainOptionNoAndSlugToOptions = (
    mainOptionNo,
    mainOptionSlug,
    options
  ) => {
    const newOptions = {
      ...options,
    };
    for (const optionNo in newOptions.items) {
      newOptions.items[optionNo] = {
        ...newOptions.items[optionNo],
        mainOptionNo: mainOptionNo,
        mainOptionSlug: mainOptionSlug,
        slug:
          newOptions.items[optionNo].slug ||
          (newOptions.items[optionNo].title &&
            newOptions.items[optionNo].title.toLowerCase()),
      };
    }
    return newOptions;
  };
  const eatOptions = {
    mainOptionSlug: "eat",
    items: {
      9: {
        title: "Eat",
      },
      3: {
        title: "Brunch",
      },
      4: {
        title: "South Asian",
      },
      8: {
        title: "East Asian",
      },
      10: {
        title: "Mediterranean",
      },
      14: {
        title: "Eastern European",
      },
      15: {
        title: "Western European",
      },
      2: {
        title: "American",
      },
      5: {
        title: "Latin American",
      },
      7: {
        title: "Middle Eastern",
      },
      11: {
        title: "British",
      },
      13: {
        title: "African",
      },
      17: {
        title: "Caribbean",
      },
    },
    questions: [
      {
        slug: "dietaryRequirements",
        question: "Dietary requirements?",
        options: [
          {
            answer: "yes",
            additionalNotes: true,
          },
          {
            answer: "no",
            additionalNotes: false,
          },
        ],
        type: "radio",
      },
    ],
  };

  const handleQuestionAnswered = (
    mainOptionSlug,
    questionSlug,
    answer,
    additionalNotes
  ) => {
    setShouldAnimate(false);
    console.log("question answered", questionSlug, answer, additionalNotes);
    let newSelection = { ...selection };
    newSelection[mainOptionSlug] = newSelection[mainOptionSlug] || {};
    newSelection[mainOptionSlug].additionalQuestions =
      (typeof newSelection[mainOptionSlug].additionalQuestions == "object" && {
        ...newSelection[mainOptionSlug].additionalQuestions,
      }) ||
      {};

    newSelection[mainOptionSlug].additionalQuestions[questionSlug] = {
      answer,
      additionalNotes,
      mainOptionSlug,
    };

    console.log("question answered new selection", newSelection);

    transformSelectionToArrayOfActivities(newSelection);
  };

  const playOptions = {
    mainOptionSlug: "play",
    items: {
      9: {
        title: "Play",
      },
      8: {
        title: "Fancy Dress",
      },
      10: {
        title: "Mind Games",
      },
      14: {
        title: "Get Physical",
      },
      15: {
        title: "Get Creative",
      },
      3: {
        title: "Wildlife",
      },
      4: {
        title: "Cook Up a Storm",
      },
    },
  };

  const drinkOptions = {
    mainOptionSlug: "drink",
    items: {
      9: {
        title: "Drink",
      },
      3: {
        title: "Cocktail",
      },
      4: {
        title: "Wine",
      },
      8: {
        title: "Whisky",
      },
      10: {
        title: "Gin",
      },
      14: {
        title: "Beer",
      },
      15: {
        title: "Rum",
      },
      2: {
        title: "Vodka",
      },
      5: {
        title: "Masterclasses and Tastings",
      },
      13: {
        title: "Live Music",
      },
      17: {
        title: "Non-alcoholic",
      },
    },
    // questions: [
    //   {
    //     slug: "alcohol",
    //     question: "Alcohol?",
    //     options: [
    //       {
    //         answer: "yes",
    //         additionalNotes: false,
    //       },
    //       {
    //         answer: "no",
    //         additionalNotes: false,
    //       },
    //     ],
    //     type: "radio",
    //   },
    // ],
  };

  const getSweatyOptions = {
    mainOptionSlug: "getSweaty",
    items: {
      9: {
        title: "Get Sweaty",
      },
      3: {
        title: "Heights",
      },
      15: {
        title: "Motor Sports",
      },
      4: {
        title: "Workout",
      },
      14: {
        title: "Water",
      },
    },
  };

  const getCulturedOptions = {
    mainOptionSlug: "getCultured",
    items: {
      9: {
        title: "Get Cultured",
      },
      3: {
        title: "History",
      },
      15: {
        title: "Exhibitions",
      },
      4: {
        title: "Science",
      },
      14: {
        title: "Art",
      },
    },
  };

  const entertainOptions = {
    mainOptionSlug: "entertain",
    items: {
      9: {
        title: "Entertain",
      },
      3: {
        title: "Music Vibes",
      },
      15: {
        title: "Sit Back and Watch",
      },
      4: {
        title: "Get Involved",
      },
      14: {
        title: "Laugh Out Loud",
      },
    },
  };
  const mainOptions = {
    mainOptionSlug: "main",
    items: {
      9: {
        title: "",
      },
      3: {
        slug: "eat",
        title: "Eat",
        options: addMainOptionNoAndSlugToOptions(3, "eat", eatOptions),
      },
      8: {
        title: "Drink",
        slug: "drink",
        options: addMainOptionNoAndSlugToOptions(8, "drink", drinkOptions),
      },
      14: {
        slug: "play",
        title: "Play",
        options: addMainOptionNoAndSlugToOptions(14, "play", playOptions),
      },
      10: {
        title: "Get Sweaty",
        slug: "getSweaty",
        options: addMainOptionNoAndSlugToOptions(
          10,
          "getSweaty",
          getSweatyOptions
        ),
      },
      4: {
        title: "Get Cultured",
        slug: "getCultured",
        options: addMainOptionNoAndSlugToOptions(
          4,
          "getCultured",
          getCulturedOptions
        ),
      },
      15: {
        title: "Entertain",
        slug: "entertain",
        options: addMainOptionNoAndSlugToOptions(
          15,
          "entertain",
          entertainOptions
        ),
      },

      // 14: {
      //   title: "Get Cultured",
      //   slug: "getCultured",
      //   options: addMainOptionNoAndSlugToOptions(
      //     14,
      //     "getCultured",
      //     getCulturedOptions
      //   ),
      // },
    },
  };

  let [cellIndexContent, setCellIndexContent] = useState({});

  const updateCellIndexContent = (content) => {
    let cssProperties = ["left", "right", "top", "bottom"];

    for (let cellNo in content.items) {
      for (let property of cssProperties) {
        if (!content.items[cellNo][property]) {
          content.items[cellNo][property] = defaultPositions[cellNo]
            ? defaultPositions[cellNo][property]
            : null;
        }
      }
    }
    setCellIndexContent(content);
  };

  const init = () => {
    setShouldAnimate(true);
    updateCellIndexContent(mainOptions);
    setIsInSubCategory(false);
    window.scroll(0, 0);
  };

  useEffect(() => {
    // Test
    init();

    redirectIfNotValidUpUntilKey("what");
  }, []);

  const getOptionBySlug = (slug) => {
    if (slug === "main") {
      return mainOptions;
    } else {
      let options = mainOptions.items;
      for (let optionNo in options) {
        if (options[optionNo].slug === slug) {
          return options[optionNo].options;
        }
      }
    }
  };

  useEffect(() => {
    console.log("selection updated", selection);
  }, [selection]);

  const transformSelectionToArrayOfActivities = (newSelection) => {
    let activities = [];
    console.log("question transform newSelection", newSelection);
    for (let activityKey in newSelection) {
      let activityObj = {
        activity: activityKey,
        selections: [],
        // additionalQuestions: [],
      };
      for (let categoryKey in newSelection[activityKey]) {
        if (categoryKey === "additionalQuestions") {
          console.log("question - is additionalQuestions");
          activityObj.additionalQuestions =
            newSelection[activityKey][categoryKey];
          console.log("question activitiy obj", activityObj);
          continue;
        } else {
          console.log("question - is NOT additionalQuestions", categoryKey);
        }
        if (newSelection[activityKey][categoryKey]) {
          activityObj.selections.push(categoryKey);
        }
      }
      activities.push(activityObj);
    }
    console.log("question activities", activities);
    setSelectionForKey(activities);
  };

  const toggleSelectedOption = ({ mainOptionNo, optionNo }) => {
    setShouldAnimate(false);
    let mainSlug = mainOptions.items[mainOptionNo].slug;
    let optionSlug = cellIndexContent.items[optionNo].slug;
    console.log("toggleSelectedOption Toggle", mainSlug, optionSlug);

    let newSelection = { ...selection };
    console.log("toggleSelectedOption newSelection", newSelection);
    newSelection[mainSlug] = newSelection[mainSlug] || {};
    newSelection[mainSlug][optionSlug] = !newSelection[mainSlug][optionSlug];
    transformSelectionToArrayOfActivities(newSelection);
  };

  const handleClickedCell = ({ cellNo }) => {
    if (cellNo === 9) {
      //Main
      init();
      return false;
    }

    let option = cellIndexContent.items[cellNo];
    console.log("handleClickedOption", cellNo, option);

    if (option.options) {
      updateCellIndexContent(option.options);
      setIsInSubCategory(true);
    } else {
      toggleSelectedOption({
        mainOptionNo: option.mainOptionNo,
        optionNo: cellNo,
      });
    }
  };

  const handleClickedCancelCell = ({ cellNo }) => {
    let option = cellIndexContent.items[cellNo];
    if (isInSubCategory) {
      return;
    }

    setShowConfirm({
      ...showConfirm,
      show: true,
      onNegativeBtnClick: () => {
        let slug = option.slug;
        let newSelection = { ...selection };
        newSelection[slug] = {};
        transformSelectionToArrayOfActivities(newSelection);
        setShowConfirm({
          ...showConfirm,
          show: false,
        });
      },
    });
  };

  const goBackToMainOptions = () => {
    // validate cellIndexContent with selection e.g. eat should have additionalQuestions and notes answered
    console.log(
      "goBackToMainOptions",
      "cellIndexContent",
      cellIndexContent,
      "selection",
      selection
    );

    let mainOptionSlug = cellIndexContent.mainOptionSlug;
    let questions = cellIndexContent.questions;
    if (!questions || questions.length === 0) {
      // No questions to validate
      return handleClickedCell({ cellNo: 9 });
    }

    let selectedObj = selection[mainOptionSlug];

    if (!selectedObj) {
      // No selection made
      return handleClickedCell({ cellNo: 9 });
    }

    if (Object.keys(selectedObj).length === 0) {
      // No selection made
      // return alert("Please select at least 1 preference");
      return handleClickedCell({ cellNo: 9 });
    }

    if (!selectedObj) {
      // No selection made
      return handleClickedCell({ cellNo: 9 });
    }

    if (!selectedObj.additionalQuestions) {
      let msg = "please ensure you've answered all of the required questions";
      if (mainOptionSlug === "eat") {
        msg = "please ensure you enter dietary requirements below";
      }
      return alert(msg);
    }

    for (let i = 0; i < questions.length; i++) {
      let question = questions[i];
      let questionSlug = question.slug;
      let selectedQuestion = selectedObj.additionalQuestions[questionSlug];
      if (!selectedQuestion) {
        return alert(
          "please ensure you've answered all of the required questions and added any necessary notes"
        );
      }

      let answer = selectedObj.additionalQuestions[questionSlug].answer;
      console.log(
        "goBackToMainOptions questionSlug",
        questionSlug,
        "answer",
        answer,
        "selectedQuestion",
        selectedQuestion,
        "questions",
        questions
      );

      let option = question.options.find((option) => {
        return option.answer === answer;
      });

      let requiresAdditionalNotes = option && option.additionalNotes;

      if (requiresAdditionalNotes) {
        if (
          !selectedQuestion.additionalNotes ||
          selectedQuestion.additionalNotes.length <= 2
        ) {
          return alert(
            "please ensure you've added any additional notes as required"
          );
        }
      }

      // if (!option) {
      //   alert("issue");
      // }

      let optionRequiresAdditionalNotes = option.additionalNotes;

      console.log(
        "optionRequiresAdditionalNotes",
        optionRequiresAdditionalNotes
      );
    }

    handleClickedCell({ cellNo: 9 });
  };

  return (
    <Base
      footerDisableNext={false}
      footerUseDoneBtn={isInSubCategory}
      footerOnClickedNext={
        isInSubCategory
          ? goBackToMainOptions
          : () => {
              if (keyIsValidated("what")) {
                history.push("/anything");
              } else {
                setShowErrorMsg(true);
              }
            }
      }
      title="What?"
      infoBody="select the activities you want to do, we’ll pick 1 or more surprise(s) (depending on time and budget)"
      footerOnClickedBack={isInSubCategory ? goBackToMainOptions : null}
      disableNav={isInSubCategory}
    >
      <MirumModal
        show={showErrorMsg}
        onPositiveBtnClick={() => {
          setShowErrorMsg(false);
        }}
        onDidDismiss={() => {
          setShowErrorMsg(false);
        }}
        hideNegativeBtn={true}
      >
        <div>
          <h1>select preferences</h1>
          <p className="my-4">
            please ensure you've selected at least 3 preferences in total before
            proceeding
          </p>
        </div>
      </MirumModal>

      <MirumModal
        show={showConfirm.show}
        onPositiveBtnClick={showConfirm.onPositiveBtnClick}
        onDidDismiss={showConfirm.onDidDismiss}
        hideNegativeBtn={false}
        negativeBtnText="Remove this"
        positiveBtnBody="No, keep it"
        onNegativeBtnClick={showConfirm.onNegativeBtnClick}
      >
        <div>
          <h1>{showConfirm.title}</h1>
          <p className="my-4">{showConfirm.body}</p>
        </div>
      </MirumModal>

      <p className="lowercase">(Select at least 3 preferences)</p>
      <div className="w-full md:w-7/12 mx-auto relative md:z-20 pb-8 mt-4 md:mt-[-3%] ">
        <BubblesGrid
          cellIndexContent={cellIndexContent}
          onClickedCell={handleClickedCell}
          onClickedCancelCell={handleClickedCancelCell}
          onQuestionAnswered={handleQuestionAnswered}
          selection={selection}
          shouldAnimate={shouldAnimate}
          isWithinSubCategory={isInSubCategory}
        />
        {!keyIsValidated("what") && (
          <Warning msg="please ensure you've selected at least 3 preferences" />
        )}
      </div>
    </Base>
  );
};

export default What;
